import React from 'react';

const PriorityBox = props => {

    // Tomo los props
    const { priority, audiences } = props;

     // Traducción de las prioridades nuevas a los ids viejos
    const priorityMap = {
        low: 3,
        medium: 2,
        high: 1,
    };

    // Renderizo
    return (
        <div className="col-xl-3 col-md-6 mb-4">
            <div className={`card border-left-${priority.css} shadow h-100 py-2`}>
                <div className="card-body">
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                            <div className={`text-xs font-weight-bold text-${priority.css} text-uppercase mb-1`}>
                                Audiencias ({priority.descripcion})
                            </div>
                            <div className="h5 mb-0 font-weight-bold text-gray-800">
                                {   audiences.filter(audience => {
                                        const audiencePriority =
                                            audience.prioridad?.id ??
                                            priorityMap[audience.priority];

                                        return audiencePriority === priority.id;
                                    }).length
                                }
                            </div>
                        </div>
                        <div className="col-auto">
                            <i className="fas fa-exclamation-triangle fa-2x text-gray-300"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PriorityBox;